import dayjs from 'dayjs'
import { formatString } from '../../../utils'


export const getLatestStatus = (order) => {
    if (order?.customOrderStatus?.length > 0) {
        return [...order.customOrderStatus].sort((a, b) =>
            dayjs(b.timestamp).diff(dayjs(a.timestamp))
        )[0].status
    }
    return order?.status
}


export const getStatusLabel = (status, isCactusAdmin) => {
    switch (status) {
        case 'REQUESTED':
            return 'Requested'
        case 'APPROVED':
            return 'Approved'
        case 'SUBMITTED_TO_CACTUS':
            return isCactusAdmin ? 'Received' : 'Sent to Cactus'
        case 'PROCESSING':
            return 'Processing'
        case 'SHIPPED':
            return 'Shipped'
        case 'REJECTED':
            return 'Rejected'
        default:
            return formatString(status)
    }
}


export const getCustomerDisplayName = (order) => {
    const pendingHistory = order?.customOrderStatus?.find(h => h.status === 'REQUESTED')
    const fullName =
        pendingHistory?.operatorUser?.name ||
        order?.shippingAddress?.fullName ||
        [order?.firstName, order?.lastName].filter(Boolean).join(' ') ||
        order?.customer?.name ||
        order?.user?.name ||
        order?.customerName

    const clean = fullName?.trim()
    return clean ? clean : 'Unknown Customer'
}

export const getRoleFromBrand = (brand) => {
    if (!brand) return 'Admin'
    const b = brand.toLowerCase()
    if (b === 'cactus') return 'Cactus (Manufacturer)'
    if (b === 'saddlefitadmin') return 'SaddleFit'
    return brand
}

export const getActorFromHistory = (history, order) => {
    if (history?.status === 'REQUESTED') {
        return {
            name: getCustomerDisplayName(order),
            role: 'Customer',
        }
    }

    // Admin / operator
    if (history?.operatorUser && (history.operatorUser.name || history.operatorUser.id || history.operatorUser.brand)) {
        const role = getRoleFromBrand(history.operatorUser.brand)
        return {
            name: history.operatorUser.name || role,
            role,
        }
    }

    // Cactus / assigned user
    if (history?.assignedUser && (history.assignedUser.name || history.assignedUser.id || history.assignedUser.brand)) {
        const role = getRoleFromBrand(history.assignedUser.brand)
        return {
            name: history.assignedUser.name || role,
            role,
        }
    }

    return { name: 'System', role: 'System' }
}


export const getStatusBadgeClass = (status) => {
    const statusLower = status?.toLowerCase() || 'pending'
    return `status-badge status-${statusLower}`
}

export const formatLocation = (shippingAddress) => {
    return [shippingAddress?.city, shippingAddress?.state, shippingAddress?.country]
        .filter(Boolean)
        .join(', ') || 'N/A'
}
